import { setItem } from "@lib/storage";
import {
  GET_ALL_CATEGORIES,
  GET_ALL_CATEGORIES_SUCCESS,
  RESET_CATEGORIES_STATE,
  GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST,
  GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS,
  UPDATE_RECENT_SEARCH_DATA,
} from "./actionTypes";

const initState = {
  allCategories: [],
  categoriesWithProductTypes: [],
  searchInputPlaceholder: "",
  searchNoProductFoundMessage: "",
};

export const actions = {
  getAllCategories() {
    return {
      type: GET_ALL_CATEGORIES,
    };
  },
  getAllCategoriesSuccess(payload) {
    return {
      type: GET_ALL_CATEGORIES_SUCCESS,
      payload,
    };
  },
  // TODO remove, added to debug race cond
  // reset() {
  //   return {
  //     type: RESET_CATEGORIES_STATE
  //   }
  // },
  getAllPrimaryCategoriesWithProductTypesRequest: () => ({
    type: GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST,
  }),
  gegetAllPrimaryCategoriesWithProductTypesSuccess: (
    categoriesWithProducts,
  ) => ({
    // type: GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS,
    // payload,
    type: GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS,
    categoriesWithProductTypes: categoriesWithProducts.tags,
    searchInputPlaceholder: categoriesWithProducts.input_placeholder,
    searchNoProductFoundMessage:
      categoriesWithProducts.no_products_found_message,
  }),
  updateRecentSearchData: (payload = []) => ({
    type: UPDATE_RECENT_SEARCH_DATA,
    payload,
  }),
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case GET_ALL_CATEGORIES_SUCCESS: {
      let { payload = [] } = action;

      // Store categories in local storage
      // TODO - this is left here because notifications depend on it
      (async () => {
        await setItem(
          "products_category",
          JSON.stringify(payload),
        );
      })();

      let categoriesCopy = [];

      categoriesCopy = payload.categories.map((category) => {
        let cat_slug = "";
        let sub_categories = [];
        if (category.sub_categories.length) {
          cat_slug = category.sub_categories
            .map((x) => x.name_hi)
            .filter((x) => x)
            .join(", ");
          sub_categories = category.sub_categories.map((cat) => {
            let ptype = cat.producttype
              .map((x) => x.producttype_name_hi)
              .filter((x) => x)
              .join(", ");
            return {
              ...cat,
              sub_cat_slug: ptype,
            };
          });
        }
        return {
          ...category,
          sharingLink: payload.sharingLink,
          cat_slug,
          sub_categories,
        };
      });

      if (Array.isArray(payload) && payload.length) {
        let hotDeals = payload.find(
          (category) => category.category_url === "hot-deals",
        );

        if (hotDeals) {
          categoriesCopy = [
            hotDeals,
            ...payload.filter(
              (category) => category.category_url !== "hot-deals",
            ),
          ];
        } else {
          categoriesCopy = [...payload];
        }
      }

      return {
        ...state,
        allCategories: categoriesCopy,
      };
    }

    case GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS: {
      const { payload = {} } = action || {};
      return {
        ...state,
        // categoriesWithProductTypes: payload,
        categoriesWithProductTypes: action && action.categoriesWithProductTypes,
        searchInputPlaceholder: action && action.searchInputPlaceholder,
        searchNoProductFoundMessage:
          action && action.searchNoProductFoundMessage,
      };
    }

    case UPDATE_RECENT_SEARCH_DATA: {
      let tags = action.payload;
      let updatedCat = state.categoriesWithProductTypes.map((x) => {
        if (x.id === "recent-searches") {
          x.tags = tags;
          return x;
        } else {
          return x;
        }
      });
      return {
        ...state,
        categoriesWithProductTypes: updatedCat,
      };
    }

    case RESET_CATEGORIES_STATE: {
      return initState;
    }

    default:
      return state;
  }
};

reducer.initialState = initState;

export default reducer;
